// Dashboard translations (en-US), loaded into common/i18n/en-US.js as `dashboard`
// Keys missing here fall back to pt-BR (fallbackLocale)
module.exports = {
  title: "Dashboard",
  placeholder: "Page under construction — the content comes in a later task.",
  overview: {
    ...require("./overview/en-US.totals"),
    menu: "Overview",
    title: "Overview",
    description: "The overall VOXGO numbers, accumulated since the beginning.",
    kpis: {
      totalUsers: "Total users",
      activeUsers: "Active users in the period",
      activeUsers7d: "Active users 7 days",
      activeUsers30d: "Active users 30 days",
      newUsers: "New users",
      newUsersPerDay: "Average new per day",
      growth: "Growth vs. previous period",
      onlineNow: "Users online now",
      avgSession: "Average time in the app",
      sessionsPerUser: "Average sessions per user",
      eventsCreated: "Events created",
      eventClicks: "Event clicks",
    },
    info: {
      totalUsers: "Accounts registered on the platform on the last day of the period.\nSource: Firebase (sign-up counters).",
      activeUsers: "Unique users who used the app at least once in the period.\nSource: Firebase (activity log sent by the apps).",
      activeUsers7d: "Unique users who used the app in the 7 days up to the end of the period.\nSource: Firebase (activity log sent by the apps).",
      activeUsers30d: "Unique users who used the app in the 30 days up to the end of the period.\nSource: Firebase (activity log sent by the apps).",
      newUsers: "Accounts created in the period.\nSource: Firebase (sign-up counters).",
      newUsersPerDay: "Average accounts created per day in the period.\nSource: Firebase (sign-up counters).",
      growth: "Change in new users vs. the previous period of the same length.\nSource: Firebase (sign-up counters).",
      onlineNow: "Users with the app open in the last 30 minutes, in real time (does not depend on the period).\nSource: Firebase (presence signal sent by the apps).",
      avgSession: "Average length of each app session in the period.\nSource: Firebase (activity log sent by the apps).",
      sessionsPerUser: "Average times each active user opened the app in the period.\nSource: Firebase (activity log sent by the apps).",
      eventsCreated: "Events created in the period.\nSource: Firebase (event counters).",
      eventClicks: "Clicks on event links in the period.\nSource: Firebase (event counters).",
    },
    hints: {
      window7: "7 days up to the end of the period",
      window30: "30 days up to the end of the period",
      shorterThan7: "period shorter than 7 days",
      shorterThan30: "period shorter than 30 days",
      oneDay: "1-day period",
      growth: "new users",
      onlineNow: "last 30 minutes",
    },
    modals: {
      activeUsers: "Active users",
      activeUsersSubtitle: "daily average of active users",
      avgSession: "Average time per session",
    },
    panels: {
      evolution: "Evolution — new users by {gran}",
      windows: "New users — this period vs. previous ones",
      windowsNote: "Each bar has the length of the selected period.",
      actives: "Active users (average) by {gran}",
      events: "Events created by {gran}",
    },
    minutes: "{value} min",
    maps: {
      users: {
        title: "Users",
        tabs: {total: "Total", continents: "Continents", countries: "Countries"},
        labels: {total: "registered users", continents: "registered users", countries: "registered users"},
      },
      events: {
        title: "Events",
        tabs: {all: "All", active: "Active", perDay: "Average per day"},
        labels: {all: "events created up to the end of the period", active: "active events on the last day of the period", perDay: "events created per day in the period (average), by country on the map"},
      },
      voxpoints: {
        title: "VoxPoints",
        tabs: {total: "Total"},
        labels: {total: "active VoxPoints"},
      },
    },
    panelInfo: {
      usersMap: {
        total: "Users registered on the last day of the period, by city of the address.\nSource: Firebase (sign-up counters).",
        continents: "Users registered on the last day of the period, by continent of the address.\nSource: Firebase (sign-up counters).",
        countries: "Users registered on the last day of the period, by country of the address.\nSource: Firebase (sign-up counters).",
      },
      eventsMap: {
        all: "Events created from the start up to the end of the period, deleted ones included, by city.\nSource: Firebase (event counters).",
        active: "Active events running on the last day of the period, by place.\nSource: Firebase (events).",
        perDay: "Average events created per day in the period; on the map, the daily average of each country.\nSource: Firebase (event counters).",
      },
      voxpointsMap: {
        total: "VoxPoints active on the last day of the period, one pin per VoxPoint.\nSource: Firebase (VoxPoints).",
      },
      evolution: "Accounts created in each interval of the period.\nSource: Firebase (sign-up counters).",
      windows: "Accounts created in this period and in the previous ones of the same length.\nSource: Firebase (sign-up counters).",
      actives: "Average active users per day in each interval.\nSource: Firebase (activity log sent by the apps).",
      events: "Events created in each interval.\nSource: Firebase (event counters).",
    },
  },
  users: require('./en-US.users.js'),
  events: require('./en-US.events.js'),
  usage: require('./en-US.usage.js'),
  moderation: require('./en-US.moderation.js'),
  period: {
    presets: {
      today: "Today",
      yesterday: "Yesterday",
      last7: "Last 7 days",
      last30: "Last 30 days",
      last90: "Last 90 days",
      thisMonth: "This month",
      thisYear: "This year",
    },
    startDate: "Start date",
    endDate: "End date",
    apply: "Apply",
    period: "Period:",
    day: "day | days",
    chartsBy: "Charts by",
    comparedWith: "Compared with",
    granularity: {
      hour: "hour",
      day: "day",
      week: "week",
      month: "month",
    },
    comparison: {
      previousDay: "vs. previous day",
      previousMonth: "vs. previous month",
      previousYear: "vs. previous year",
      previousPeriod: "vs. previous period",
    },
    modalFooter: "Period: {range} · by {gran}",
  },
  header: {
    updatedNow: "Updated just now",
    updatedAgo: "Updated {n} min ago",
  },
  kpi: {
    expand: "Expand",
    live: "Live",
  },
  state: {
    loading: "Loading…",
    empty: "No data in the selected period.",
    unavailable: "n/a",
    unavailableHint: "Not available for the selected period.",
  },
  modal: {
    close: "Close",
  },
  chart: {
    noData: "no data",
  },
  map: {
    roadmap: "Map",
    satellite: "Satellite",
    less: "Less",
    more: "More",
    andMore: "and {n} more",
    fullscreen: "Full screen",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
  },
  cohort: {
    week: "Week",
    month: "Month",
    users: "Users",
    weekColumn: "Wk {n}",
    dayColumn: "Day {n}",
  },
  format: {
    thousand: "{value}k",
    million: "{value}M",
    duration: "{minutes} min {seconds} s",
    percentagePoints: "{value} p.p.",
  },
};
